const BHCPF_NAME = 'Basic Healthcare Provision Fund';
const BHCPF_AGENCY_ID = '313923';

function hasBhcpfSector(item) {
  return item.sectors && item.sectors.some(s => s.name === BHCPF_NAME);
}

/**
 * Returns true when both conditions are met:
 *   1. agencyId is the BHCPF agency
 *   2. enrollee belongs to the BHCPF sector
 */
export function isBhcpfContext(agencyId, enrollee) {
  return (
    String(agencyId) === BHCPF_AGENCY_ID &&
    enrollee &&
    enrollee.sector === BHCPF_NAME
  );
}

/**
 * Filters a list of services or drugs:
 *   - BHCPF context  → keep only BHCPF items
 *   - Non-BHCPF context → exclude all BHCPF items
 */
export function applyBhcpfFilter(list, bhcpfContext) {
  return bhcpfContext
    ? list.filter(hasBhcpfSector)
    : list.filter(item => !hasBhcpfSector(item));
}
